import React from 'react';

import Icon from '../../../components/AppIcon';

const LumoCharacter = () => {
  return (
    <div className="relative w-full max-w-md mx-auto mb-8">
      <div className="relative aspect-square rounded-3xl overflow-hidden bg-gradient-to-br from-primary/10 to-accent/10 p-8 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5 animate-pulse-subtle" />
        <div className="relative z-10 w-full h-full flex items-center justify-center">
          <div className="w-48 h-48 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center shadow-elevated">
            <Icon name="Sparkles" size={80} color="#FFFFFF" />
          </div>
        </div>
        <div className="absolute top-4 right-4 bg-accent text-accent-foreground px-4 py-2 rounded-full text-sm font-semibold flex items-center gap-2 shadow-card">
          <Icon name="Zap" size={16} />
          <span>AI Coach</span>
        </div>
      </div>
      <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-background border border-border px-6 py-3 rounded-full shadow-card">
        <p className="text-lg font-bold text-foreground">Meet Lumo</p>
      </div>
    </div>
  );
};

export default LumoCharacter;